import './index.css';
import { useFormContext } from 'react-hook-form';
import { disableHandleOnWheel } from '@/utils';

const renderLabelOutside = (name, label) => (
	<label className="input__label" htmlFor={name}>
		{label}
	</label>
);

const Input = ({
	name,
	label,
	type,
	expanded = false,
	validationSchema,
	className,
	disabled = false,
	placeholder,
	onChange,
	value,
	defaultValue,
	useReactForm = true,
}: Props): JSX.Element => {
	const register = useReactForm ? useFormContext().register : () => {};

	return (
		<div className={`input__container ${expanded ? 'w-full' : ''}`}>
			{label && renderLabelOutside(name, label)}
			<input
				type={type}
				defaultValue={defaultValue}
				value={value}
				id={name}
				name={name}
				className={`input__box
                             ${expanded ? 'w-full' : ''}
                             ${className}`}
				disabled={disabled}
				placeholder={placeholder}
				onChange={onChange}
				{...register(name, validationSchema)}
				onWheel={disableHandleOnWheel}
			/>
		</div>
	);
};

export default Input;
